export const mobile = 320;
export const tablet = 768;
export const desktop = 960;


export const mobileQuery = "320";
export const tabletQuery = "600";
export const desktopQuery = "960";